import React, { useCallback, useEffect, useState, lazy } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const NutritionistOpinion = () => {
  return <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6 md:p-8 mb-12" data-id="element-308">
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8" data-id="element-309">
        <div className="w-24 h-24 md:w-32 md:h-32 rounded-full flex-shrink-0 overflow-hidden" data-id="element-310">
          <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80" alt="Dra. Laura Sánchez" className="w-full h-full object-cover" data-id="element-311" />
        </div>
        <div data-id="element-312">
          <p className="italic text-gray-700 text-base md:text-lg mb-4" data-id="element-313">
            "Como nutricionista especializada en familias latinas, puedo
            confirmar que este sistema no solo ahorra tiempo y dinero, sino que
            también proporciona una nutrición balanceada que respeta nuestras
            tradiciones culinarias. Las recetas están perfectamente diseñadas
            para mantener el equilibrio entre sabor, nutrición y practicidad."
          </p>
          <p className="font-bold text-lg" data-id="element-314">Dra. Laura Sánchez</p>
          <p className="text-gray-600" data-id="element-315">
            Nutricionista Clínica • Especialista en Nutrición Familiar
          </p>
        </div>
      </div>
    </div>;
};
const VisualTestimonials = () => {
  const testimonials = [{
    id: 1,
    text: 'Con este sistema, ¡mi cocina dejó de ser un caos! 🙌',
    name: 'Mafe',
    role: 'Mamá emprendedora',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3okc9V2SnPSdwmD1uHbaWh/Testimonio_Mafe_%282%29.jpg'
  }, {
    id: 2,
    text: 'Ya no me estreso por la cena. Mi hija hasta cocina conmigo. Este sistema nos salvó la rutina 🙌',
    name: 'Karen',
    role: 'Mamá de tiempo completo',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jwsxEogiQ1vJ955RibNp74/Testimonio_Karen_%283%29.jpg'
  }, {
    id: 3,
    text: 'Este libro me devolvió la tranquilidad en las tardes 🌿',
    name: 'Ana María',
    role: 'Mamá de 3 • Ama de casa',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nEap89o6YSkX2i8Qs8RieU/Testimonio_Yayi_%281%29.jpg'
  }];
  return <div data-id="element-316">
      <div className="text-center mb-12" data-id="element-317">
        <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-318">
          Lo dicen con fotos 📸
        </h2>
        <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-319">
          Estas mamás compartieron cómo cambió su rutina con La Cena Que Te
          Salva
        </p>
      </div>
      <div className="flex flex-col md:grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-320">
        {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 flex flex-col" data-id="element-321">
            <div className="w-full" data-id="element-322">
              <img src={testimonial.image} alt={`${testimonial.name} usando La Cena Que Te Salva`} className="w-full h-auto" loading="lazy" data-id="element-323" />
            </div>
            <div className="p-6 flex-grow" data-id="element-324">
              <p className="text-gray-700 mb-4 italic" data-id="element-325">"{testimonial.text}"</p>
              <div data-id="element-326">
                <p className="font-bold text-[#438A52]" data-id="element-327">{testimonial.name}</p>
                <p className="text-sm text-gray-600" data-id="element-328">{testimonial.role}</p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};
const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const testimonials = [{
    id: 1,
    text: 'Antes gastaba casi $15 diarios en comidas improvisadas o delivery. Con este sistema, ahora gasto menos de $5 al día y mis hijos están comiendo mucho más sano. ¡La mejor inversión que he hecho este año!',
    name: 'María López',
    role: 'Mamá de 2 • Cliente desde 2023',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
  }, {
    id: 2,
    text: 'No puedo creer lo fácil que es seguir este sistema. Las recetas son realmente rápidas y a mis tres hijos les encantan. La lista de compras me ahorra tanto tiempo en el supermercado que ya no siento ese estrés semanal.',
    name: 'Carmen Rodríguez',
    role: 'Mamá de 3 • Cliente desde 2022',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
  }, {
    id: 3,
    text: 'Trabajo tiempo completo y siempre llegaba cansada sin ideas para la cena. Este ebook cambió todo. Las recetas son tan rápidas y deliciosas que mi familia piensa que paso horas cocinando. ¡El menú semanal es oro puro!',
    name: 'Julia Méndez',
    role: 'Mamá de 2 • Cliente desde 2023',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
  }];
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
  }, [testimonials.length]);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
  }, [testimonials.length]);
  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swipe left
      nextSlide();
    }
    if (touchStart - touchEnd < -50) {
      // Swipe right
      prevSlide();
    }
  };
  // Auto-scroll effect
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);
  return <div className="w-full bg-white py-16" data-id="element-329">
      <div className="container mx-auto px-4" data-id="element-330">
        <div className="text-center mb-12" data-id="element-331">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-332">
            Mamás como tú ya transformaron su rutina de cenas
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-333">
            Estas son las experiencias reales de familias que ahora disfrutan de
            cenas tranquilas, nutritivas y económicas
          </p>
        </div>
        {/* Testimonial Carousel */}
        <div className="max-w-5xl mx-auto relative" data-id="element-334">
          <div className="overflow-hidden" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-335">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }} data-id="element-336">
              {testimonials.map(testimonial => <div key={testimonial.id} className="w-full flex-shrink-0 px-4" data-id="element-337">
                  <div className="bg-[#DEEFE1] p-6 rounded-lg shadow-md" data-id="element-338">
                    <div className="flex mb-3" data-id="element-339">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-340" />)}
                    </div>
                    <p className="text-gray-700 mb-4 italic" data-id="element-341">
                      "{testimonial.text}"
                    </p>
                    <div className="flex items-center" data-id="element-342">
                      <div className="w-12 h-12 rounded-full mr-3 overflow-hidden" data-id="element-343">
                        <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-344" />
                      </div>
                      <div data-id="element-345">
                        <p className="font-bold" data-id="element-346">{testimonial.name}</p>
                        <p className="text-sm text-gray-600" data-id="element-347">
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute top-1/2 left-0 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md z-10 hover:bg-white transition-colors duration-300" aria-label="Previous testimonial" data-id="element-348">
            <ChevronLeftIcon className="w-5 h-5 text-[#438A52]" data-id="element-349" />
          </button>
          <button onClick={nextSlide} className="absolute top-1/2 right-0 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md z-10 hover:bg-white transition-colors duration-300" aria-label="Next testimonial" data-id="element-350">
            <ChevronRightIcon className="w-5 h-5 text-[#438A52]" data-id="element-351" />
          </button>
          {/* Navigation Dots */}
          <div className="flex justify-center space-x-2 mt-6" data-id="element-352">
            {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`w-3 h-3 rounded-full transition-colors duration-300 ${idx === currentSlide ? 'bg-[#438A52]' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-353" />)}
          </div>
        </div>
        {/* Nutritionist Opinion - Added before Visual Testimonials */}
        <div className="mt-16 mb-8" data-id="element-354">
          <NutritionistOpinion data-id="element-355" />
        </div>
        {/* Visual Testimonials Section */}
        <VisualTestimonials data-id="element-356" />
        {/* Empty div for spacing, image removed */}
        <div className="mt-12 text-center" data-id="element-357"></div>
      </div>
    </div>;
};
export default Testimonials;